// @ts-nocheck
import styled from 'styled-components';
import type { StatelessFunctionalComponent } from 'react';
import { getTheme } from 'settings/theme/index';

const {
  palette: { primary, greyscale },
  noodera: { fontTypes, spacing },
} = getTheme();
export const Button: StatelessFunctionalComponent<any> = styled.button`
  width: fit-content;
  padding: 0 ${spacing.x5};
  border-radius: 12px;
  color: ${primary.hundred};
  border: 1px solid ${primary.hundred};
  background: ${greyscale.white};
  ${fontTypes.font4Medium};
  ${(props) =>
    props.active && `background: ${primary.twenty}; border-color:${primary.hundredTwenty};}`}
`;
